import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import ArticleBlockItem from '../article-block-item/article-home';


import { LoadingCircle } from '../../../components/common/loading';
class InsightPage extends PureComponent {

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.onEndReachedCall = this.onEndReachedCall.bind(this);
    this.props.getInsightsData();
  }

  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight) {
      this.onEndReachedCall();
    }
  }


  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }


  onEndReachedCall(){
    console.log("onEndReachedCall!");
    
        this.props.setBusy();
    
        setTimeout(() => {
          this.props.getInsightsData();
        }, 500);

  }

  render(){
    const articleList = this.props.cioinsights.articleList;
    const { i18n: { messages }} = this.props;
    
    if(!articleList){
      return(
        <div className="pad-bottom-30">
          <LoadingCircle isPage={true}/>
        </div>
      );
    } else if(articleList.length <= 0) {
      return(
        <div className="scene">
            <div className="pad-top-50">
              <center>{messages['app.insight.noArticle']}</center>
            </div>  
        </div>
      );
    }
    else{
      return(

          <div className="scene">
            <div className="container1">
              <ArticleBlockItem data={articleList}/>

              { this.props.cioinsights.busy &&
                <LoadingCircle />
              }
            </div>
          </div>

      );
    }
  }

}

export default createContainer({
  $queries: {
    getInsightsData: {
      $call: 'cioinsights.getData',
    },

    setBusy: {
      $call: 'cioinsights.setBusy',
    },


    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    cioinsights: {
      busy: true,
      articleList : true
    },
  }
})(InsightPage);


